const UploadStatus = Object.freeze({
  /** WAIT_TO_UPLOAD = 0 */
  WAIT_TO_UPLOAD: 0,
  /** UPLOADED = 1 */
  UPLOADED: 1
})

const PartnerProductStatus = Object.freeze({
  /** DISABLE = 0 */
  DISABLE: 0,
  /** ENABLE = 1 */
  ENABLE: 1
})

const PartnerIDs = Object.freeze({
  PChome: 1,
  KKday: 2,
  Eatigo: 3
})

const PartnerType = Object.freeze({
  Client: 0,
  Supplier: 1
})

const PartnerProductMappingType = Object.freeze({
  /** BY_FUNNOW = 0 */
  BY_FUNNOW: 0,
  /** BY_PARTNER = 1 */
  BY_PARTNER: 1
})

const PartnerStatus = Object.freeze({
  /** DISABLE = 0 */
  DISABLE: 0,
  /** ENABLE = 1 */
  ENABLE: 1
})

const PartnerRemarkLimitIds = Object.freeze([
  1, // Name
  14, // Name (HK)
  36, // Name (passport)
  2, // Mobile number
  5 // Email
])

export {
  UploadStatus,
  PartnerProductStatus,
  PartnerIDs,
  PartnerType,
  PartnerProductMappingType,
  PartnerStatus,
  PartnerRemarkLimitIds
}
